import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectAllNodes, selectAllPoints } from '../map/slice/mapSelectors';
import { usePanMap } from '../plotter/usePanMap';
import { itemClicked } from '../selectedItems/selectedItemsSlice';

export const useFocusPoint = () => {
  const panMap = usePanMap();
  const dispatch = useDispatch();

  const points = useSelector(selectAllPoints);
  const nodes = useSelector(selectAllNodes);

  const focusPoint = useCallback(
    (pointId: string | number | null | undefined, zoom: number = 11) => {
      if (!pointId) {
        return false;
      }
      const point = points[pointId];

      if (!point || !point.node) {
        return false;
      }
      const node = nodes[point.node];
      if (!node) {
        return false;
      }

      panMap({ lat: Number(node.lat), lng: Number(node.lng) }, zoom);
      dispatch(itemClicked({ id: point.id, itemType: 'point' }));
      return true;
    },
    [dispatch, nodes, panMap, points],
  );

  return focusPoint;
};
